import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Megaphone, Users, CalendarCheck } from "lucide-react";

export function HireProvidersBanner({ compact = false }: { compact?: boolean }) {
  return (
    <section className={compact ? "px-4 py-4" : "container px-4 pb-0 pt-8 md:pt-12"}>
      <div className="relative overflow-hidden rounded-2xl border border-primary/20 bg-gradient-to-br from-primary/10 via-background to-secondary/10 p-5 md:p-8">
        <div className="flex flex-col items-start gap-4 md:flex-row md:items-center md:justify-between">
          <div className="flex items-start gap-3 md:gap-4">
            <div className="rounded-xl bg-primary/15 p-2.5 text-primary md:p-3">
              <Megaphone className="h-5 w-5 md:h-6 md:w-6" />
            </div>
            <div>
              <h3 className="text-base font-bold md:text-xl">Hiring multiple providers?</h3>
              <p className="mt-1 text-sm text-muted-foreground">
                Broadcast one job invitation, get applications from verified providers, and schedule interviews — all in one place.
              </p>
              <div className="mt-2 hidden flex-wrap gap-3 text-xs text-muted-foreground md:flex">
                <span className="inline-flex items-center gap-1"><Users className="h-3 w-3" /> Reach 10, 50 or all matching providers</span>
                <span className="inline-flex items-center gap-1"><CalendarCheck className="h-3 w-3" /> Built-in interview scheduling</span>
              </div>
            </div>
          </div>
          <div className="flex w-full gap-2 md:w-auto">
            <Button asChild size={compact ? "sm" : "default"} className="flex-1 md:flex-none">
              <Link to="/jobs/new">Post a job</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}